





























import Vue from 'vue';

export default Vue.extend({
  props: {
    title: {
      type: String,
    },
    showModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    showModal: function(val) {
      this.visible = val;
    },
  },
  methods: {
    onClose() {
      this.visible = false;
      setTimeout(() => this.$emit('close'), 150);
    },
  },
});
